import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import api from "../core/api"

import Recibos from "../components/recibos/index"
import Repasses from "../components/repasses/index"
import Back from "../components/Back"

class ContratoDetail extends React.Component {
    state = {
        carregando: true,
        carregandoAcao:false,
        contrato: {},
        anos:[]
    }

    componentDidMount() {
        let id = this.props.match.params.id
        api.get("/contratos/" + id)
            .then(response => {
                let anos = this.anosExtratos(response.data.contrato)
                this.setState({ carregando: false, contrato: response.data.contrato,anos })
            })
            .catch(err => {})
    }
    anosExtratos = (contrato) =>{
        let dt = new Date();
        let anoAtual = dt.getFullYear();
        let anos = []
        let [inicio] = contrato.vigencia.split(" ");
        let [ano] = inicio.split('/').reverse();
        for(let i=ano;i<=anoAtual;i++){
            anos.push(i);
        }
        return anos
    }
    extratoRedimento = (ano)=>{
        const {contrato} = this.state
        api.post("/contratos/buscaextratos",{ano,contrato:contrato.id}).then(response=>{
            const {link} = response.data
            window.open(link, '_blank');
        })
    }
    render() {
        const { contrato,anos } = this.state
        return (
            <section className="section">
                <div className="container content">
                    <div className="card">
                        {this.state.carregando ? (
                            <div className="card-content">Aguarde...</div>
                        ) : (
                            <>
                                <header className="card-header content-header">
                                    <Back />
                                    <h3 className="title is-5 nomargin">
                                        Detalhes do contrato {contrato.codigo}
                                    </h3>
                                </header>
                                <div className="card-content">
                                    {contrato.participacao === "Locatario" ? (
                                        <Recibos contrato={contrato} anos={anos} extratoRedimento={this.extratoRedimento}/>
                                    ) : (
                                        <Repasses contrato={contrato} anos={anos} extratoRedimento={this.extratoRedimento}/>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => ({
    contrato: state.contrato
})

export default withRouter(connect(mapStateToProps)(ContratoDetail))
